<script setup lang="ts">
import type { RoadmapItem } from '../../models/whatsNew.types'

import { useI18n } from '@/shared/i18n'
import { Badge, Button } from '@/shared/ui'
import { RichTextViewer } from '@/shared/ui/editor'

defineProps<{ item: RoadmapItem; voted: boolean }>()
const emit = defineEmits<{ vote: [] }>()
const { t } = useI18n()
</script>

<template>
  <article class="grid gap-sm rounded-lg border border-border bg-surface p-md">
    <header class="flex items-center justify-between gap-sm">
      <h3 class="m-0 text-sm font-semibold">{{ item.title }}</h3>
      <Badge tone="neutral" size="sm">{{ item.status }}</Badge>
    </header>
    <RichTextViewer :content="item.description" />
    <footer class="flex items-center justify-between gap-sm">
      <span class="text-xs text-muted">{{ item.eta }}</span>
      <Button
        size="xs"
        :variant="voted ? 'soft' : 'outline'"
        :aria-label="
          t(voted ? 'globalSurface.whatsNew.unvote' : 'globalSurface.whatsNew.vote', {
            title: item.title,
          })
        "
        @click="emit('vote')"
      >
        {{ item.votes }}
      </Button>
    </footer>
  </article>
</template>
